import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { configureAmplify } from './auth/amplify';
import { SessionProvider } from './auth/session';

// Amplify must be configured before anything reads the session. Sign-in
// itself lives on the login app (REACT_APP_LOGIN_URL); the session is
// shared through parent-domain cookies (see auth/amplify.ts).
configureAmplify()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <SessionProvider>
          <App />
        </SessionProvider>
      </Provider>
    </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
